import axios from 'axios'
import { session, KEY_MEDIATEK_2025GIVINGTREE_TOKEN } from '@/tools/storage'
import config from '@/tools/configs'
import router from '@/router'

const getUrl = (url) => {
  return config.server + config.reqlApi + '/mediatek' + url
}

// 从查询字符串中删除指定参数
const removeQueryParam = (search, paramName) => {
  if (!search) return ''
  const params = new URLSearchParams(search)
  params.delete(paramName)
  const result = params.toString()
  return result ? '?' + result : ''
}

const checkTokenValid = (response) => {
  if (response.status === 200) {
    if (response.data.code === 100 && response.data.error === 'TOKEN_EXPIRED') {
      session.remove(KEY_MEDIATEK_2025GIVINGTREE_TOKEN)
      router.replace(`/mediatek-2026givingtree/login?tips=登入身份過期，請重新登入&redirect=${window.location.pathname + removeQueryParam(window.location.search, 'redirect')}`)
      throw new Error(response.data.error)
    }

    if (response.data.code === 101 && response.data.error === 'TOKEN_INVALID') {
      session.remove(KEY_MEDIATEK_2025GIVINGTREE_TOKEN)
      router.replace(`/mediatek-2026givingtree/login?tips=登入信息無效，請重新登入&redirect=${window.location.pathname + removeQueryParam(window.location.search, 'redirect')}`)
      throw new Error(response.data.error)
    }

    if (response.data.code === 102 && response.data.error === 'TOKEN_ABSENT') {
      session.remove(KEY_MEDIATEK_2025GIVINGTREE_TOKEN)
      router.replace(`/mediatek-2026givingtree/login?tips=登入信息無效，請重新登入&redirect=${window.location.pathname + removeQueryParam(window.location.search, 'redirect')}`)
      throw new Error(response.data.error)
    }

    if (response.data.error) {
      throw new Error(response.data.error)
    }

    return response.data
  }
}

const fetch = (method, url, { data, headers = {} } = {}) => {
  let token = session.get(KEY_MEDIATEK_2025GIVINGTREE_TOKEN)
  const reqHeaders = {
    'Content-Type': 'application/json',
    ...headers
  }
  if (token) {
    reqHeaders['Authorization'] = `Bearer ${token}`
  }
  const reqConfig = {
    method,
    url: getUrl(url),
    headers: reqHeaders
  }

  if (method === 'get' || method === 'delete') {
    reqConfig.params = data
  } else {
    reqConfig.data = data
  }

  return axios(reqConfig)
    .then(res => {
      return checkTokenValid(res)
    })
}

const doGet = (url, params = {}) => {
  return fetch('get', url, { data: params })
}

const doPost = (url, data) => {
  return fetch('post', url, { data })
}

export default {
  login (account, password) {
    return doPost('/auth/login', { account, password })
  },
  logout () {
    return doPost('/auth/logout')
  },
  getWishList ({ page, status, batch, schoolName, type, organizerId, wishNo, keyword, isMine }) {
    const query = (status ? `&status=${status}` : '') + (schoolName ? `&school_name=${schoolName}` : '') +
      (wishNo ? `&wish_no=${wishNo}` : '') + (keyword ? `&keyword=${keyword}` : '') + (isMine ? '&is_mine=1' : '')
    return doGet(`/wishes?page=${page}${query}&batch=${batch}&type=${type || 0}&organizer_id=${organizerId || 1}`)
  },
  getWishItem (id) {
    return doGet(`/wishes/${id}`)
  },
  donate (id, data) {
    return doPost(`/wishes/${id}/donate`, data)
  },
  getMyDonates ({ page, status, batch, schoolName, type, organizerId, wishNo, keyword }) {
    const query = (status ? `&status=${status}` : '') + (schoolName ? `&school_name=${schoolName}` : '') +
      (wishNo ? `&wish_no=${wishNo}` : '') + (keyword ? `&keyword=${keyword}` : '')
    return doGet(`/wishes/myDonate?page=${page}${query}&batch=${batch}&type=${type || 0}&organizer_id=${organizerId || 1}`)
  },
  getWishCount ({ batch, schoolName, organizerId }) {
    const query = (schoolName ? `&school_name=${schoolName}` : '') + (organizerId ? `&organizer_id=${organizerId}` : '')
    return doGet(`/wishes/count?batch=${batch}${query}`)
  },
  getWishTimes (batch) {
    return doGet(`/wishes/times?batch=${batch}`)
  },
  getSchools ({ batch = '', organizerId }) {
    return doGet(`/wishes/schools?batch=${batch}&organizer_id=${organizerId}`)
  }
}
